<template lang="pug">
  .crud
    modal-purchase-requisitions-detail(:detail='detail', :index='index', :is-add='isModalAdd')
    modal-contact(:detail='detail', :index='index', :is-add='isModalAdd')
    modal-import-restrictions(model="purchase-requisitions" :title="$t('front.import_modal', {model: $t('strings.restriction')})")
    .container-fluid
      vm-row.heading(vm-w="12")
        img(src="@/assets/banner.jpg" width="600")
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.inventories') }}:
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(v-if="$auth.check('Admin')" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportRestrictionsVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
      vm-row(vm-w="12")
        vm-col.card(vm-justify="center", vm-align="center", vm-w="8")
          vm-table(v-model="selected"  max-height="35px" :data="inventories")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                div
                  vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small")
                    div(v-for="(item,index) in columns")
                      vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('inventories.'+ item) + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('inventories.'+ item) + ', desc'")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('inventories.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-if="parseFloat(tr.quantity) !== 0" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'unit_measurement_id'") {{data[indextr][column]}}
                  slot(v-if="column == 'unit_measurements_id'") {{data[indextr]['unit_measurement']['symbol']}}
                vm-td
                  vm-button(type="default" radius icon="plus" @click="addPurchaseRequisitionDetail(data[indextr])")
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
        vm-col(type="flex" vm-justify="center", vm-align="center", vm-w="4").card
          .dRes
            h2 Orden de Requisicion
            .dCar(v-for="(detail, index) in details")
              .dDt(@click="editPurchaseRequisitionDetail(detail, index)")
              vm-row(vm-w="12")
                vm-col(vm-align="right" vm-w="11")
                  h4(class="rg") {{`${detail.quantity} ${detail.unit_measurement} de ${detail.product}`}} &nbsp; <br>
                    .row_total.old_price(v-if="checkDiscount(detail) && detail.original_total !== 0 && !isNaN(detail.original_total)") {{detail.original_total | currency }}
                    .row_total(v-bind:class="{success_badge: checkDiscount(detail)}") {{detail.total | currency }}
              .dBt
                vm-button(radius color="dark" type="flat" icon="close-circle-outline" size="large" @click="deletePurchaseRequisitionDetailConfirm(detail, index)")
            vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
              vm-col
                b Total:&nbsp;&nbsp;
                span.old_price(style="font-size: 1rem;" v-if="anyDiscount") {{ og_total | currency }}
                span(style="font-size: 1.2rem;") {{ total | currency }}
              vm-col(vm-justify="center", vm-align="center", vm-w=12)
                vm-chip(v-if="parseFloat(total) > 999" color="#24c1a0") Felicidades! Tu compra no lleva costo de envío
                .shipping-text(v-if="total < 1000")
                  vm-icon(icon="car-outline")
                  span &nbsp; Costo del Envio $35.00 pesos + iva <br>
                  span.smallText &nbsp; * La compra minima es de $250.00
            vm-button#addPR(v-if="details.length > 0 && saveBtn && total > 249" class="bCob" color="primary" size="large" @click="saveRecord") Añadir Requisicion
    footer-controlla
</template>
<script>
import ModalPurchaseRequisitionsDetail from '@/components/modals/ModalPurchaseRequisitionsDetail.vue'
import FooterControlla from '@/components/FooterControlla.vue'
import ModalContact from '@/components/modals/ModalContact.vue'
import ModalImportRestrictions from '@/components/modals/ModalImportRestrictions.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Pos')

export default {
  name: 'Pos',
  components: {
    FooterControlla,
    ModalPurchaseRequisitionsDetail,
    ModalContact,
    ModalImportRestrictions
  },
  props: {
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    saveBtn: true,
    currentPage: 1,
    isModalAdd: true,
    newRecord: {
      quantity_max: 0,
      details: []
    },
    detail: {
      email: '',
      phone: '',
      full_name: ''
    },
    index: 0,
    selected: [],
    enabledDelete: false,
    columns: [
      'product',
      'quantity',
      'unit_measurement',
      'unit_price'
    ],
    status: [
    ],
    filters: {
      // NotPurchaseRequisitiona: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        product: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      includes: '', // Agrega las relaciones separados con coma y sin espacio
      orderBy: ''
    }
  }),
  async created () {
    this.currentPage = this.pagination.currentPage
    this.inventories.length === 0 && await this.getInventories(this.currentPage)
    this.getCatalog()
  },
  methods: {
    checkDiscount (detail) {
      if (detail.hasDiscount === 1) {
        return detail.hasDiscount === 1
      }
    },
    ...mapActions([
      'addPurchaseRequisition',
      'loadInventories',
      'loadCatalog',
      'actionInventory',
      'setModalImportVisible',
      'deletePurchaseRequisitionDetail',
      'setModalVisible',
      'setModalImportRestrictionsVisible',
      'applyFilter',
      'clearFilter'
    ]),
    saveRecord () {
      this.saveBtn = false
      this.addPurchaseRequisition({ amount: this.total, og_total: this.og_total, unit_measurement: this.detail.unit_measurement, details: this.details }).then(() => { this.$router.push({ name: 'pos' }) })
    },
    addPurchaseRequisitionDetail (inventory) {
      this.saveBtn = true
      this.isModalAdd = true
      this.setModalVisible(true)
      this.detail = {
        product: inventory.product,
        quantity: 0,
        original_total: 0,
        quantity_max: inventory.quantity,
        discount_quantity: inventory.discount_quantity,
        sku: inventory.sku,
        unit_measurement: inventory.unit_measurement,
        unit_price: inventory.unit_price,
        discount_price: inventory.discount_price,
        inventory_id: inventory.id,
        email: this.$auth.user().email,
        phone: this.$auth.user().phone,
        full_name: this.$auth.user().name
      }
    },
    editPurchaseRequisitionDetail (detail, index) {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.detail = { ...detail }
      this.index = index
    },
    async saveDetail () {
      if (!this.enabledSave) return
      this.enabledSave = false
      let t = this
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#saveRecord',
        scale: 0.45
      })
      await this.isModalAdd ? this.addPurchaseRequisition(this.newRecord).then(() => { t.$router.push({ name: 'requisitions' }) }) : this.editRequisition(this.newRecord).then(() => { t.$router.push({ name: 'requisition' }) })
    },
    async deletePurchaseRequisitionDetailConfirm (detail, index) {
      let t = this
      this.auxDeletePurchaseRequisitionDetail = () => {
        t.deletePurchaseRequisitionDetail({ detail, index }).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.purchase_requisition'), attribute: detail.id ? detail.id : index }),
        accept: this.auxDeletePurchaseRequisitionDetail
      })
    },
    async deleteInventoryConfirm (inventory) {
      let t = this
      this.auxDeleteInventory = () => {
        t.deleteInventory(inventory).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.inventory'), attribute: this.$t(inventory.sku) }),
        accept: this.auxDeleteInventory
      })
    },
    async setActionInventory (record, action) {
      record.id && this.actionInventory({ id: record.id, action })
    },
    async getInventories (page) {
      let t = this
      this.loadInventories({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let inventory = this.inventories.filter(inventory => inventory.id === parseInt(index))[0]
      inventory && this.editInventory(inventory, index)
    },
    async getCatalog () {
      Object.keys(this.inventoriesCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    }
  },
  computed: {
    ...mapGetters([
      'purchaseRequisition',
      'inventories',
      'inventoriesCatalog',
      'pagination',
      'filterParams',
      'details'
    ]),
    detailsLength () {
      return this.detail.length
    },
    enabledEdit () {
      return this.id
    },
    total () {
      return this.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    },
    og_total () {
      return this.details.reduce((prev, cur) => prev + parseFloat(cur.original_total), 0).toFixed(2)
    },
    anyDiscount () {
      return this.details.find(e => e.hasDiscount === 1 && true)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getInventories(currentPage)
    },
    filterParams (filter) {
      filter.length === 0 && (this.filters.whereIn = {
        // filters
      })
      // filter.length === 0 && (this.filters.betweenDates.created_at = [])
      filter.length === 0 && (this.filters.where.param = '')
      this.selected = []
      this.currentPage = 1
      filter.length === 0 && this.applyFilter(this.filters)
      this.getInventories(this.currentPage)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  }
}
</script>

<style lang="scss">
.smallText {
  font-size: 11px;
}
.shipping-text {
  width: 100%;
  padding: 8px 15px;
  border: 1px solid rgba(0,0,0,.05);
  border-radius: 5px;
}
.old_price {
  padding: 0 5px;
  border-radius: 3px;
  font-size: 0.8rem;
  color: #949494;
  display: inline-block;
  text-decoration: line-through;
}
.success_badge {
  background: #2ecc71;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 0.9rem;
  color: white;
  display: inline-block;
}
.crud {
  padding-top: 134px !important;
}
.heading {
  display: block !important;
  text-align: center;
  margin: 0 !important;
  padding: 0 !important;
}
.score-card{
padding: 5px;
margin: 10px;
}
.dCar {
  border-bottom: 1px solid #e4e4e4;
  margin:3%;
  position:relative;
  padding: 15px;
  text-align: right;
  cursor:pointer;
  .dBt {
    position: absolute;
    right: -.2rem;
    top: .65rem;
  }
}
.dRes h2{
  text-align: center;
  border-bottom: .02rem solid gray;
}
.bCob {
    float:right;
    margin-top: 2rem;
}
.dRes {
    position: relative;
    width: 100%;
    padding: 2rem;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
